/**
 * ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
 * Bangalore, India. All Rights Reserved.
 */
import {
  PolymerElement,
  html
} from "@polymer/polymer/polymer-element.js";
import {
  mixinBehaviors
} from "@polymer/polymer/lib/legacy/class.js";
import '../behaviors/log-out-behaviour.js';
import '../behaviors/prelogin-auth-submit.js';
import '../behaviors/mpin-register-behaviour.js';

class mpinPreloginAuth extends mixinBehaviors([sbBehaviours.forgotUserName, corpBehaviours.logOutBehaviour, corpBehaviours.mpinRegisterBehaviour], PolymerElement) {
  /** Properties definition*/
  static get properties() {
    return {
      selectedPage: {
        type: Number,
        notify: true,
        observer: 'addFocusToDebitCardHeader'
      },
      profilePage: {
        type: Boolean,
        value: false,
        notify: true
      },
      pinLabel: {
        type: String,
        notify: true,
        value: getLabel('l_PIN')
      }
    };
  }
  /** HTML template definition*/


  static get template() {
    return html`
        <style include="app-styles">
        .toast-message {
          --paper-toast-background-color: var(--critical-label-color);
          --paper-toast-color: var(--primary-light-color);
        }
  
        .stepupauthbtn,
        .background-transparent {
          background-color: transparent;
        }
  
        fin-auth-element-wrapper {
          --message-style: {
            color: var(--primary-light-color);
          }
          --app-border-color: var(--primary-light-color);
          --app-font-color: var(--primary-light-color);
          --font-style: {
            color: var(--primary-light-color);
          }
        }
				</style>
        <app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>
        <oe-ajax id="logoutAjax" method="post" content-type="application/json" body="{{objData}}" on-response="_handleResponse" on-error="_handleError"></oe-ajax>
        <div class="mdl-grid mdl-grid--no-spacing" phone$="{{phone}}">
          <div class="mdl-cell--8-col mdl-cell--6-col-desktop position-relative">
            <div class="banner-skew banner-brand full-width mdl-cell--hide-tablet" phone$="{{phone}}"></div>
            <div class="mdl-grid mdl-cell mdl-cell--hide-tablet position-relative mdl-cell--1-offset-desktop mdl-grid--no-spacing mdl-cell--6-col-desktop">
              <!--<div class="mdl-grid"></div>-->
              <div class="mdl-grid  mdl-cell"></div>
              <div class="mdl-grid  mdl-cell"></div>
              <div class="mdl-grid  mdl-cell"></div>
              <div class="mdl-grid  mdl-cell"></div>
              <div class="mdl-grid  mdl-cell"></div>
              <div class="outlineOffset mdl-grid mdl-cell" id="headerAuth" tabindex="0"></div>
              <div class="mdl-cell mdl-grid mdl-cell--12-col primary-light-text-xl">
                <oe-i18n-msg  msgid="h_Authentication"></oe-i18n-msg>
              </div>
              <div class="mdl-grid  mdl-cell"></div>
            </div>
    
            <div class="mdl-grid "></div>
            <div class="mdl-grid "></div>
            <div class="mdl-grid "></div>
            <paper-card class="list-card background-transparent light-input-style" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}" elevation="0">
              <fin-auth-element-wrapper id="preAuthWrapper" otp-link={{otpLink}} isvalid="{{isvalid}}" auth-method="{{authMethod}}" class="mdl-cell mdl-cell--4-col-phone   mdl-cell--8-col-tablet"
               phone$="{{phone}}" tablet$="{{tablet}}" desktop$="{{desktop}}"></fin-auth-element-wrapper>
               <div class="mdl-grid "></div>
               <div class="mdl-grid "></div>
               <div class="mdl-grid "></div>
               <div class="mdl-grid mdl-cell  mdl-grid--no-spacing content-align-center">
                <paper-button id="preAuthCancel" class="secondary-button" on-tap="cancelPage" raised>
                  <oe-i18n-msg id="pwdCancel" class="" msgid="b_Cancel"></oe-i18n-msg>
                </paper-button>
                <paper-button id="preAuthsubmit" class="primary-button" on-tap="_handleSubmit" raised>
                  <oe-i18n-msg class="primary-light-color" id="pwdProceed" msgid="b_Continue"></oe-i18n-msg>
                </paper-button>
              </div>
              <paper-toast id="preAuthTost" class="toast-message"></paper-toast>
            </paper-card>
          </div>
        </div>`;
  }
  updateAuthMethod() {
    this.authMethod = [];
    this.authMethod = [{
      method: 'SOTP',
      wrapperValue: "",
      resend: "./random_link/"
    }];
  }
  _isValidChanged() {
    if (this.$.preAuthsubmit) {
      this.$.preAuthsubmit.disabled = !this.isvalid;
      this.$.preAuthsubmit.toggleClass("text-brand-color", this.isvalid);
    }
  }
  _handleSubmit() {
    var self = this;
    self.valiateOTP();
  }
  _callSucessPage() {
    if (!this.authenticationValidation(this.authMethod) && this.enabledAuthList[0] === "oneTimePassword") {
      this.enabledAuthList.shift();
      this.authorizationDetailsBody.oneTimePassword = sbEncrypt.decrypt(this.otpValue);
      this.otp = this.otpValue;
      if (this.enabledAuthList.length > 0) this.selectedPage = this.authPage[this.enabledAuthList[0]];
      else this.postRequest();
    }
  }
  authenticationValidation(autharray) {
    var self = this;
    var authMethodLength = autharray.length;

    for (var i = 0; i < authMethodLength; i++) {
      if (autharray[i].method == "OTP" || autharray[i].method == "SOTP") {
        self.otpValue = autharray[i].wrapperValue;

        if (!autharray[i].wrapperValue) {
          this.$["preAuthTost"].text = getLabel("m_OTPMandatory");
          this.$.preAuthTost.show();
          return true;
        }
      } else if (autharray[i].method == "TPWD") {
        self.otpValue = autharray[i].wrapperValue;

        if (!autharray[i].wrapperValue) {
          self.fire('oe-show-error', getLabel("m_TPWDMandatory"));
          return true;
        }
      }
    }
  }
  cancelPage() {
    if (!this.profilePage) this.goToLoginPage();
    else {
      this.backToMyProfile();
    }
  }
  addFocus() {
    if (this.selectedPage == 0) {
      this.$.headerAuth.focus();
    }
  }
}
customElements.define('mpin-prelogin-auth', mpinPreloginAuth);